<template>
  <!-- Image Preview -->
  <v-dialog
    v-model="showDialog"
    max-width="800"
    @click:outside="closePreview"
    @keydown.esc="closePreview"
  >
    <v-card max width="800">
      <v-card-title>
        <v-icon
          class="img-preview-close"
          @click="closePreview"
          :title="$t('label.close')"
        >
          mdi-close
        </v-icon>
      </v-card-title>

      <v-card-text class="text-center">
        <img class="img-preview-img" fluid :src="imagePath" />
      </v-card-text>
    </v-card>
  </v-dialog>
  <!-- Image Preview -->
</template>

<script>
export default {
  name: "image-preview",
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    imagePath: {
      type: String,
      default: "",
    },
  },
  methods: {
    closePreview() {
      this.$emit("closePreview");
    },
  },
};
</script>
